import { ObjectiveProperties } from 'apps/web/enums/pageKey';
import { CategorizedVerb, IPlanObjetiveKeyword } from 'apps/web/types/page';
import { getLocalStorageItem } from 'apps/web/utils/helper';
import { parseJSON } from 'apps/web/utils/parseJson';

import { Language } from '@lessonPlanner/enums';

import OBJECTIVE_FORM_KEYS from './formKeys';

const formDefaultValues = () => ({
  localObjective: {
    [OBJECTIVE_FORM_KEYS.subject]: getLocalStorageItem(
      ObjectiveProperties.subject,
    ),
    [OBJECTIVE_FORM_KEYS.gradeLevel]: getLocalStorageItem(
      ObjectiveProperties.gradeLevel,
    ),
    [OBJECTIVE_FORM_KEYS.competency]: getLocalStorageItem(
      ObjectiveProperties.competency,
    ),
    [OBJECTIVE_FORM_KEYS.language]: getLocalStorageItem(
      ObjectiveProperties.language,
      Language.ENGLISH,
    ),
    [OBJECTIVE_FORM_KEYS.cognitiveVerbs]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.cognitiveVerbs),
      [] as CategorizedVerb[],
    ),

    [OBJECTIVE_FORM_KEYS.psychomotorVerbs]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.psychomotorVerbs),
      [] as CategorizedVerb[],
    ),
    [OBJECTIVE_FORM_KEYS.affectiveVerbs]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.affectiveVerbs),
      [] as CategorizedVerb[],
    ),
  },

  defaultObjective: {
    [OBJECTIVE_FORM_KEYS.subject]: getLocalStorageItem(
      ObjectiveProperties.subject,
    ),
    [OBJECTIVE_FORM_KEYS.gradeLevel]: getLocalStorageItem(
      ObjectiveProperties.gradeLevel,
    ),
    [OBJECTIVE_FORM_KEYS.competency]: getLocalStorageItem(
      ObjectiveProperties.competency,
    ),
    [OBJECTIVE_FORM_KEYS.language]: Language.ENGLISH,

    [OBJECTIVE_FORM_KEYS.cognitiveVerbs]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.cognitiveVerbs),
      [] as CategorizedVerb[],
    ),

    [OBJECTIVE_FORM_KEYS.psychomotorVerbs]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.psychomotorVerbs),
      [] as CategorizedVerb[],
    ),
    [OBJECTIVE_FORM_KEYS.affectiveVerbs]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.affectiveVerbs),
      [] as CategorizedVerb[],
    ),
  },

  americanObjective: {
    [OBJECTIVE_FORM_KEYS.curriculumFramework]: getLocalStorageItem(
      ObjectiveProperties.curriculumFramework,
    ),
    [OBJECTIVE_FORM_KEYS.subject]: getLocalStorageItem(
      ObjectiveProperties.subject,
    ),
    [OBJECTIVE_FORM_KEYS.gradeLevel]: getLocalStorageItem(
      ObjectiveProperties.gradeLevel,
    ),
    [OBJECTIVE_FORM_KEYS.specificStandards]: getLocalStorageItem(
      ObjectiveProperties.specificStandards,
    ),
    [OBJECTIVE_FORM_KEYS.objectives]: getLocalStorageItem(
      ObjectiveProperties.objectives,
    ),
    [OBJECTIVE_FORM_KEYS.language]: getLocalStorageItem(
      ObjectiveProperties.language,
      Language.ENGLISH,
    ),
  },

  iplanObjective: {
    [OBJECTIVE_FORM_KEYS.subject]: getLocalStorageItem(
      ObjectiveProperties.subject,
    ),
    [OBJECTIVE_FORM_KEYS.gradeLevel]: getLocalStorageItem(
      ObjectiveProperties.gradeLevel,
    ),
    [OBJECTIVE_FORM_KEYS.competency]: getLocalStorageItem(
      ObjectiveProperties.competency,
    ),
    [OBJECTIVE_FORM_KEYS.language]: getLocalStorageItem(
      ObjectiveProperties.language,
      Language.ENGLISH,
    ),
    [OBJECTIVE_FORM_KEYS.cognitiveVerbs]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.cognitiveVerbs),
      [] as CategorizedVerb[],
    ),

    [OBJECTIVE_FORM_KEYS.psychomotorVerbs]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.psychomotorVerbs),
      [] as CategorizedVerb[],
    ),
    [OBJECTIVE_FORM_KEYS.affectiveValuesVerbs]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.affectiveValuesVerbs),
      [] as CategorizedVerb[],
    ),
    [OBJECTIVE_FORM_KEYS.affectiveValuesVerbs2]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.affectiveValuesVerbs2),
      [] as CategorizedVerb[],
    ),
    [OBJECTIVE_FORM_KEYS.affectiveValuesVerbs3]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.affectiveValuesVerbs3),
      [] as CategorizedVerb[],
    ),
    [OBJECTIVE_FORM_KEYS.affectiveAttitudesVerbs]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.affectiveAttitudesVerbs),
      [] as CategorizedVerb[],
    ),
    [OBJECTIVE_FORM_KEYS.affectiveAttitudesVerbs2]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.affectiveAttitudesVerbs2),
      [] as CategorizedVerb[],
    ),
    [OBJECTIVE_FORM_KEYS.affectiveAttitudesVerbs3]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.affectiveAttitudesVerbs3),
      [] as CategorizedVerb[],
    ),
    [OBJECTIVE_FORM_KEYS.valuesList]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.valuesList),
      [] as IPlanObjetiveKeyword[],
    ),
    [OBJECTIVE_FORM_KEYS.valuesList2]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.valuesList2),
      [] as IPlanObjetiveKeyword[],
    ),
    [OBJECTIVE_FORM_KEYS.valuesList3]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.valuesList3),
      [] as IPlanObjetiveKeyword[],
    ),
    [OBJECTIVE_FORM_KEYS.attitudesList]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.attitudesList),
      [] as IPlanObjetiveKeyword[],
    ),
    [OBJECTIVE_FORM_KEYS.attitudesList2]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.attitudesList2),
      [] as IPlanObjetiveKeyword[],
    ),
    [OBJECTIVE_FORM_KEYS.attitudesList3]: parseJSON(
      getLocalStorageItem(ObjectiveProperties.attitudesList3),
      [] as IPlanObjetiveKeyword[],
    ),
  },
});

export default formDefaultValues;
